import { render } from "./SiteToasts.vue?vue&type=template&id=a8ea8af4"
import script from "./SiteToasts.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteToasts.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sites/SiteToasts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a8ea8af4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a8ea8af4', __exports__)) {
    api.reload('a8ea8af4', __exports__)
  }
  
  module.hot.accept("./SiteToasts.vue?vue&type=template&id=a8ea8af4", () => {
    api.rerender('a8ea8af4', render)
  })

}


export default __exports__